// extracted by mini-css-extract-plugin
export default {"cls1":"CoreXNav-cls1__e7e474bb549f0d5f97d4","cls2":"CoreXNav-cls2___1dbd0205a7e65df493b CoreXNav-cls1__e7e474bb549f0d5f97d4"};